module.exports = __webpack_public_path__ + "static/media/javascript.893d98e0.svg";